  const initState = {
    memberInBodyTests: [],
    memberInBodyTestsCount: 0,
    addInBodyTestModal: false,
  };
  
  const inBodyTestReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_MEMBER_IN_BODY_TESTS":
        return {
          ...state,
          memberInBodyTests: action.payload.data,
        };
      case "SET_MEMBER_IN_BODY_TESTS_COUNT":
        return {
          ...state,
          memberInBodyTestsCount: action.payload.data,
        };
      case "ADD_IN_BODY_TEST_MODAL":
        return {
          ...state,
          addInBodyTestModal: action.payload.data,
        };
      default:
        return { ...state };
    }
  };
  
  export default inBodyTestReducer;
  